import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { parseNumber } from '../../../../core/utils/number.utils';

@Injectable()
export class PieceQuantityValidation {
  pieceQuantityValidation(realQuatity: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const pieceQuantity = parseNumber(control.value);
      return pieceQuantity !== realQuatity ? null : { is_equal: true };
    };
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/manufacturing-order-pieces-change-form/piece-quantity-validator.ts